import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/pages/index/index'
import AllNav from '@/pages/all-nav/index'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index,
      children: [
          {
              path: '',
              redirect: '/all-nav'
          },
          // 通知管理
          {
              path: '/all-nav',
              component: AllNav
          }
      ]
    }
    // ,{
    //   path: '/add-push',
    //   name: 'addpush',
    //   component: AddPush,
    // }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js